export default {"src":"/_next/static/media/author.2d8bd430.svg","height":88,"width":271,"blurWidth":0,"blurHeight":0};